import { ScoreType } from '@/domain/impact/impact.entity';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';

import { ProjectTourQuizPanel } from './ProjectTourQuizPanel';

export function SidePanelQuiz({
  project,
  selectedScoreType,
  selectedSubType,
  isQuizLayoutDisplayed,
  setIsQuizLayoutDisplayed,
}: {
  project: ProjectTour;
  selectedScoreType: ScoreType;
  selectedSubType: string;
  isQuizLayoutDisplayed: boolean;
  setIsQuizLayoutDisplayed: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <ProjectTourQuizPanel
      projectId={project.id}
      selectedScoreType={selectedScoreType}
      selectedSubType={selectedSubType}
      isQuizLayoutDisplayed={isQuizLayoutDisplayed}
      setIsQuizLayoutDisplayed={setIsQuizLayoutDisplayed}
    />
  );
}
